import { Box, BoxProps } from "@chakra-ui/react";
import { FiBox } from "react-icons/fi";

export const BoxIcon = (props: BoxProps) => {
  return <Box as={FiBox} height="20px" width="20px" {...props} />;
};
